import { useI18n } from "../i18n";
import { logWarn } from "../lib/log";
import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "../lib/api";

export const useSessionArchive = () => {
  const { t } = useI18n();
  const [sessions, setSessions] = useState([]);

  const load = useCallback(() => api.get("/sessions")
    .then((r) => setSessions(r.data))
    .catch((e) => logWarn("Caricamento archivio fallito:", e)), []);

  useEffect(() => { load(); }, [load]);

  const save = async (payload) => {
    try {
      await api.post("/sessions", payload);
      toast.success(t("saved"));
      load();
    } catch (e) {
      logWarn("Salvataggio sessione fallito:", e);
      toast.error(t("saveFail"));
    }
  };

  const remove = async (id) => {
    await api.delete(`/sessions/${id}`);
    setSessions((s) => s.filter((x) => x.id !== id));
  };

  return { sessions, save, remove };
};
